// utils/storage.js

import router from '@/router';

// 获取当前 prefix
function getPrefix() {
    return router.currentRoute.params.prefix || '';
}

// 拼接真实 key
function buildKey(key) {
    return `${getPrefix()}_${key}`;
}

const storage = {
    set(key, value) {
        const realKey = buildKey(key);

        if (typeof value === 'object') {
            localStorage.setItem(realKey, JSON.stringify(value));
        } else {
            localStorage.setItem(realKey, value);
        }
    },

    get(key, defaultValue = null) {
        const realKey = buildKey(key);

        const value = localStorage.getItem(realKey);

        if (value === null) return defaultValue;

        try {
            return JSON.parse(value);
        } catch (e) {
            return value;
        }
    },

    remove(key) {
        localStorage.removeItem(buildKey(key));
    },

    clearCurrentPrefix() {
        const prefix = getPrefix() + '_';

        Object.keys(localStorage).forEach(key => {
            if (key.startsWith(prefix)) {
                localStorage.removeItem(key);
            }
        });
    }
};

export default storage;